export default __webpack_public_path__ + "static/ogimage-bf78b607e0eff7e24970fed0d484e2fc.jpg";